import {
  EMPLOYEEASSESSMENTDETAIL_LOADING,
  GET_EMPLOYEEASSESSMENTDETAIL,
  GET_EMPLOYEEASSESSMENTDETAIL_SUCCESS,
  GET_EMPLOYEEASSESSMENTDETAIL_FAIL,
  ADD_EMPLOYEEASSESSMENTDETAIL_SUCCESS,
  ADD_EMPLOYEEASSESSMENTDETAIL_FAIL,
  DELETE_EMPLOYEEASSESSMENTDETAIL_SUCCESS,
  DELETE_EMPLOYEEASSESSMENTDETAIL_FAIL,
  UPDATE_EMPLOYEEASSESSMENTDETAIL_SUCCESS,
  UPDATE_EMPLOYEEASSESSMENTDETAIL_FAIL,
  EMPLOYEEASSESSMENTDETAIL_RESET
} from "./actionType";

const INIT_STATE = {
  employeeAssessmentDetails: [],
  error: {},
};

const EmployeeAssessmentDetail = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_EMPLOYEEASSESSMENTDETAIL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_EMPLOYEEASSESSMENTDETAIL:
          return {
            ...state,
            employeeAssessmentDetails: action.payload.data,
            isEmployeeAssessmentDetailCreated: false,
            isEmployeeAssessmentDetailSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_EMPLOYEEASSESSMENTDETAIL_FAIL:
      switch (action.payload.actionType) {
        case GET_EMPLOYEEASSESSMENTDETAIL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isEmployeeAssessmentDetailCreated: false,
            isEmployeeAssessmentDetailSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_EMPLOYEEASSESSMENTDETAIL: {
      return {
        ...state,
        isEmployeeAssessmentDetailCreated: false,
        loading: true,
      };
    }

    case EMPLOYEEASSESSMENTDETAIL_LOADING: {
      return {
        ...state,
        isEmployeeAssessmentDetailCreated: false,
        loading: true,
      };
    }

    case ADD_EMPLOYEEASSESSMENTDETAIL_SUCCESS:
      return {
        ...state,
        isEmployeeAssessmentDetailCreated: true,
        loading: false,
        employeeAssessmentDetails: [action.payload.data, ...state.employeeAssessmentDetails],
      };

    case ADD_EMPLOYEEASSESSMENTDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_EMPLOYEEASSESSMENTDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        isEmployeeAssessmentDetailCreated: true,
        employeeAssessmentDetails: state.employeeAssessmentDetails.filter(
          employeeAssessmentDetail => employeeAssessmentDetail.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_EMPLOYEEASSESSMENTDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_EMPLOYEEASSESSMENTDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        isEmployeeAssessmentDetailCreated: true,
        employeeAssessmentDetails: state.employeeAssessmentDetails.map(employeeAssessmentDetail =>
          employeeAssessmentDetail.id.toString() === action.payload.data.id.toString() ? { ...employeeAssessmentDetail, ...action.payload.data } : employeeAssessmentDetail
        ),
      };

    case UPDATE_EMPLOYEEASSESSMENTDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case EMPLOYEEASSESSMENTDETAIL_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default EmployeeAssessmentDetail;